import fuse from './fuse';
import i18n from './i18nSlice';
import user from './userSlice';
import alarms from './alarmsSlice';
import staffSlice from './staffSlice';
import floorsSlice from '../main/apps/map/store/floorsSlice';
import themeSlice from './themeSlice';
import applicationSlice from './applicationSlice';
import permissionSlice from './permissionSlice';
import deadlineDocumentSlice from './deadlineDocumentSlice';
import localNormativeActsSlice from './localNormativeActsSlice';
import birthdaysSlice from './birthdaysSlice';
import { combineReducers } from '@reduxjs/toolkit';
import { accountApi } from '../services/accountApi';
import { articlesApi } from '../services/articlesApi';
import { contractsApi } from '../services/contractsApi';
import { paymentsApi } from '../services/paymentsApi';
import { shtatApi } from '../services/shtatApi';
import { skudApi } from '../services/skudApi';
import { spApi } from '../services/spApi';
import { staffApi } from '../services/staffApi';
import { projectsApi } from '../services/ticket/projectsApi';
import { ticketsApi } from '../services/ticketsApi';
import { chatApi } from '../services/chatApi';
import { buildingsApi } from '../services/buildingsApi';
import { floorApi } from '../services/floorApi';
import { departmentsApi } from '../services/deparmentsApi';
import { resourceApi } from '../services/resourceApi';
import { claimApi } from '../services/claim/claimApi';
import { claimTypeApi } from '../services/claim/claimTypeApi';
import { claimExecutorApi } from '../services/claim/claimExecutorApi';
import { claimStatusApi } from '../services/claim/claimStatusApi';
import { rolesApi } from '../services/rolesApi';
import { adApi } from '../services/adApi';
import { leaveRequestApi } from '../services/leaveRequestApi';
import { skillApi } from '../services/skillApi';
import { skillApiGet } from '../services/skillApiGet';
import { nChatApi } from '../services/nChatApi';
import { appointmentApi } from '../services/appointmentApi';
import { templateCategoryApi } from '../services/templatesCategoryApi';
import { emojiApi } from '../services/emojiApi';
import { articlesCommentsApi } from '../services/articlesCommentsApi';
import { articlesUserReactionApi } from '../services/articlesUserReactionApi';
import { workCalendarApi } from '../services/workCalendarApi';
import { deskApi } from '../services/deskApi';
import { projectInfomationApi } from '../services/projectInfomationApi';
import { initiativeCategoryApi } from '../services/initiativeCategoryApi';
import { projectTagsApi } from '../services/projectTagsTypesApi';
import { permissionApi } from '../services/permissionApi';
import { attendanceApi } from '../services/attendanceApi';

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    fuse,
    i18n,
    user,
    alarms,
    staffSlice,
    floorsSlice,
    themeSlice,
    applicationSlice,
    permissionSlice,
    deadlineDocumentSlice,
    localNormativeActsSlice,
    birthdaysSlice,
    [accountApi.reducerPath]: accountApi.reducer,
    [adApi.reducerPath]: adApi.reducer,
    [rolesApi.reducerPath]: rolesApi.reducer,
    [shtatApi.reducerPath]: shtatApi.reducer,
    [spApi.reducerPath]: spApi.reducer,
    [staffApi.reducerPath]: staffApi.reducer,
    [ticketsApi.reducerPath]: ticketsApi.reducer,
    [articlesApi.reducerPath]: articlesApi.reducer,
    [skudApi.reducerPath]: skudApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [contractsApi.reducerPath]: contractsApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    [nChatApi.reducerPath]: nChatApi.reducer,
    [resourceApi.reducerPath]: resourceApi.reducer,
    [buildingsApi.reducerPath]: buildingsApi.reducer,
    [floorApi.reducerPath]: floorApi.reducer,
    [departmentsApi.reducerPath]: departmentsApi.reducer,
    [claimApi.reducerPath]: claimApi.reducer,
    [claimTypeApi.reducerPath]: claimTypeApi.reducer,
    [claimExecutorApi.reducerPath]: claimExecutorApi.reducer,
    [claimStatusApi.reducerPath]: claimStatusApi.reducer,
    [leaveRequestApi.reducerPath]: leaveRequestApi.reducer,
    [skillApi.reducerPath]: skillApi.reducer,
    [skillApiGet.reducerPath]: skillApiGet.reducer,
    [appointmentApi.reducerPath]: appointmentApi.reducer,
    [templateCategoryApi.reducerPath]: templateCategoryApi.reducer,
    [emojiApi.reducerPath]: emojiApi.reducer,
    [articlesCommentsApi.reducerPath]: articlesCommentsApi.reducer,
    [articlesUserReactionApi.reducerPath]: articlesUserReactionApi.reducer,
    [workCalendarApi.reducerPath]: workCalendarApi.reducer,
    [deskApi.reducerPath]: deskApi.reducer,
    [projectInfomationApi.reducerPath]: projectInfomationApi.reducer,
    [initiativeCategoryApi.reducerPath]: initiativeCategoryApi.reducer,
    [projectTagsApi.reducerPath]: projectTagsApi.reducer,
    [permissionApi.reducerPath]: permissionApi.reducer,
    [attendanceApi.reducerPath]: attendanceApi.reducer,
    ...asyncReducers,
  });

  /*
	Reset the redux store when user logged out
	 */
  if (action.type === 'user/userLoggedOut') {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export default createReducer;
